import { useEffect, useState } from 'react';
import mqtt from 'mqtt';
import { useDispatch, useSelector } from 'react-redux';
import { dispatchUiState } from '../../../domain/ui-state';
import { domainSelector } from '../../../domain/domain-redux';
export var AgentTypingIndicator = function () {
    var dispatch = useDispatch();
    var _a = useState(null), client = _a[0], setClient = _a[1];
    // Checks state whether we already received data from BE or not
    var handShakeDataString = useSelector(domainSelector.getHandshakeData);
    // MQTT logic – runs after we receive handshake data from BE
    useEffect(function () {
        if (!handShakeDataString)
            return;
        var handShakeData = JSON.parse(handShakeDataString);
        if (!handShakeData.appHandshakeDetails || !handShakeData.applicationConfig)
            return;
        var appHandshakeDetails = handShakeData.appHandshakeDetails, applicationConfig = handShakeData.applicationConfig;
        var generateRandomString = function () { return Math.random().toString(16).substr(2, 8); };
        var generateClientId = function () { var _a; return "".concat(applicationConfig.partnerId, "_").concat(applicationConfig.id, "_").concat((_a = appHandshakeDetails.chatUser) === null || _a === void 0 ? void 0 : _a.userId, "_").concat(Date.now(), "_").concat(generateRandomString()); };
        var options = {
            username: appHandshakeDetails.chatSessionToken,
            password: appHandshakeDetails.chatSessionToken,
            clientId: generateClientId(),
            clean: true,
            connectTimeout: 10 * 1000,
            keepalive: 20,
            rejectUnauthorized: false,
        };
        var mqttClient = mqtt.connect(appHandshakeDetails.inboxServerUrl, options);
        setClient(mqttClient);
        mqttClient.on('connect', function () {
            console.log('✅ MQTT Client connected');
            mqttClient.subscribe(appHandshakeDetails.userInbox);
        });
        mqttClient.on('message', function (_, messagePayload) {
            var _a, _b;
            try {
                var event_1 = JSON.parse(messagePayload.toString());
                if (((_a = event_1 === null || event_1 === void 0 ? void 0 : event_1.payload) === null || _a === void 0 ? void 0 : _a.type) === 'CHAT_USER_START_TYPING') {
                    dispatchUiState(dispatch, { is_agent_typing: true });
                }
                else if (((_b = event_1 === null || event_1 === void 0 ? void 0 : event_1.payload) === null || _b === void 0 ? void 0 : _b.type) === 'CHAT_USER_STOP_TYPING') {
                    dispatchUiState(dispatch, { is_agent_typing: false });
                }
            }
            catch (_) {
                // Should implement logger in the future
            }
        });
        mqttClient.on('error', function (err) { return console.error('❌ MQTT Error:', err); });
        mqttClient.on('close', function () { return console.log('🚪 MQTT Client Closed'); });
        return function () {
            mqttClient.end(true);
        };
    }, [handShakeDataString, dispatch]);
    return null;
};
